import { DatePipe } from '@angular/common';
import { Component, OnInit,Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ExcelService } from 'src/app/services/excel/excel.service';

@Component({
  selector: 'app-listmodal',
  templateUrl: './listmodal.component.html',
  styleUrls: ['./listmodal.component.css'],
  providers:[DatePipe]
})
export class ListmodalComponent implements OnInit,OnDestroy{
  dataToshow: any;
  isAlive: boolean = true;
  dataToDisplay = [];
  excelData = [];

  constructor(
    public dialogRef: MatDialogRef<ListmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe : DatePipe,
    private excelService : ExcelService
  ) { }
 

  ngOnInit(): void {
    this.dataToshow = this.data.data
  }

  onNoClick(){
    this.dialogRef.close()
  }

  exportAsXLSX(): void {
    this.dataToshow.forEach(element => {
      this.excelData.push({
        'Bid List Code':element.bidListCode,
        'Commodity Name':element.commodityName,
        "Total Quantity": element.totalQuantity + ' ' + element.totalQuantityUnit,
        "Price": element.price + '/' +element.startPriceUnit,
        "Bid Amount": element.bidAmount,
        "Bid Quantity": element.bidQuantity + ' ' +element.totalQuantityUnit,
        "Value": element.value,
        "Customer Name ": element.customerFullName,
        "Bidding Date ": this.datePipe.transform(element.biddingDate, 'dd-MM-yyyy, hh:mm'),
        "City": element.cityName,
        "State": element.stateName,
      })
    });
    this.excelService.exportAsExcelFile(this.excelData, 'NccfBidData');
  }

  ngOnDestroy(): void {
    this.isAlive = false
  }
}
